var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "post",
      staticClass: "canvas-area",
      style: {
        backgroundColor: "#fff",
        backgroundSize: 1600 / _vm.scale + "px " + 1600 / _vm.scale + "px",
        backgroundPosition:
          "0 0," + 800 / _vm.scale + "px " + 800 / _vm.scale + "px",
        borderWidth:
          (80 / _vm.scale) * 100 +
          "px " +
          (80 / _vm.scale) * 100 +
          "px " +
          (80 / _vm.scale) * 100 +
          "px " +
          (80 / _vm.scale) * 100 +
          "px",
        backgroundImage:
          "linear-gradient(to top right,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc),linear-gradient(to top right,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc)",
        width: _vm.postInfo.canvas.width + "px",
        height: _vm.postInfo.canvas.height + "px",
        transition: (_vm.anime ? 0.5 : 0) + "s",
        transform: "scale(" + _vm.scale / 100 + "," + _vm.scale / 100 + ") ",
        left: _vm.canvasLeft + "px",
        top: _vm.canvasTop + "px"
      },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "background",
          style: { background: _vm.postInfo.background.backgroundColor }
        },
        [
          _vm.postInfo.background.backgroundImage
            ? _c("img", {
                style: {
                  width: _vm.postInfo.background.width + "px",
                  height: _vm.postInfo.background.height + "px",
                  top:
                    "-" +
                    _vm.postInfo.background.imageInfo.backgroundPositionY +
                    "px",
                  left:
                    "-" +
                    _vm.postInfo.background.imageInfo.backgroundPositionX +
                    "px"
                },
                attrs: { src: _vm.backImageSrc }
              })
            : _vm._e()
        ]
      ),
      _vm._l(_vm.postInfo.images, function(item) {
        return _c("d-image", {
          key: item.imageId,
          attrs: { image: item, display: true }
        })
      }),
      _vm._l(_vm.postInfo.texts, function(item) {
        return _c("d-text", {
          key: item.textId,
          attrs: { textInfo: item, display: true }
        })
      }),
      _vm._l(_vm.postInfo.codes, function(item) {
        return _c("d-code", {
          key: item.codeId,
          attrs: { code: item, display: true }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }